module.exports = __webpack_public_path__ + "static/media/home_16_white.7c7dc2e7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/home_16_white.svg
// module id = 1404
// module chunks = 0